const $ = require("jquery");
const accordion = require("./accordion");
const _throttle = require("lodash/throttle");

$(function () {
    let $body = $("body"),
        $bodyWithMiniHeader = $(".ws-body--minified-header"),
        $navHeader = $(".ws-nav"),
        $megaMenu = $(".ws-megamenu"),
        $minifiedHeader = $bodyWithMiniHeader.find(".ws-minified-header"),
        $navLinks = $('.ws-table-of-contents__link'),
        miniHeaderHasProgressBar = $bodyWithMiniHeader.data("ws-minified-header-show-progress"),

        clusteredTableOfContentsSelector = ".ws-clustered-table-of-contents",
        clusteredTableOfContentsAccordionSelector = ".ws-clustered-table-of-contents.ws-accordion",
        $clusteredTableOfContents = $(clusteredTableOfContentsSelector),
        $clusteredTableOfContentsNotAccordion = $clusteredTableOfContents.not(clusteredTableOfContentsAccordionSelector),
        $clusteredTableOfContentsAccordion,
        $clusteredTableOfContentsHeading = $(".ws-clustered-table-of-contents__heading"),

        stickyMiniHeaderHeight = 60,
        stickyMiniTocHeight = 54.5,
        h2MarginBottom = 15,
        miniHeaderProgressBarHeight = 4;

    $('.ws-table-of-contents__link[href*="#"]').not('[href="#"]').click(function(event) {
        if (
            window.location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
            window.location.hostname == this.hostname
        ) {
            event.preventDefault();

            let hash = this.hash;
            let $headingTarget = $(hash);

            if ($headingTarget.length) {
                // Mimic the default in-page anchor location.hash behavior.
                // Use pushState to avoid hashchange event and its resulting page scroll.
                window.history.pushState("", "", hash);

                let headerOffset = $minifiedHeader.length
                    ? (stickyMiniHeaderHeight + (miniHeaderHasProgressBar ? miniHeaderProgressBarHeight : 0) + h2MarginBottom)
                    : (parseInt(($navHeader.length ? $navHeader.css("height") : $megaMenu.css("height")), 10) + h2MarginBottom);

                let targetScroll = $headingTarget.offset().top - headerOffset;
                if ($clusteredTableOfContentsHeading.hasClass("ws-accordion__header--active")) {
                    let tableOffset = $clusteredTableOfContents.innerHeight();
                    targetScroll = $headingTarget.offset().top - headerOffset - tableOffset;
                }
                else if ($clusteredTableOfContentsHeading.length && window.innerWidth < 992) {
                    targetScroll = $headingTarget.offset().top - headerOffset - stickyMiniTocHeight;
                }

                $("html, body").animate(
                    { scrollTop: targetScroll },
                    0,
                    function() {
                        // Allow the heading to forcibly receive focus
                        $headingTarget.attr("tabindex", -1);
                        // For accessibility, focus on heading without interrupting smooth scroll
                        $headingTarget.get(0).focus({preventScroll: true});
                    }
                );
            }
        }
    });

    if ($clusteredTableOfContents.length) {
        $clusteredTableOfContentsAccordion = $clusteredTableOfContents.siblings(clusteredTableOfContentsAccordionSelector);

        let accordionIsOpen = false;
        let bottomOfTable = $clusteredTableOfContents.offset().top + $clusteredTableOfContents.innerHeight();
        //Height of existing table plus existing 15px article content padding - the height of the miniTOC. Keeps page from shifting when TOC is minimized.
        const tableHeight = $clusteredTableOfContents.innerHeight() + 15 - stickyMiniTocHeight;

        //Custom ScrollSpy implementation created after bootstrap 5 upgrade
        let headingIds = [];
        const headings = [];

        $navLinks.each(function () {
            headingIds.push($(this).attr('href'));
        });
        headingIds.forEach(function (item) {
            headings.push($(item));
        });
        let scrollSpyHandler = _throttle(function () {
            $navLinks.each(function () {
                $(this).removeClass("active");
            });
            headings.forEach((heading) => {
                let navHeight = ($minifiedHeader && $minifiedHeader.length)
                    ? $minifiedHeader[0].offsetHeight
                    : 0;
                let headingPosition = heading[0].getBoundingClientRect().top - navHeight - 25;
                let link = "#" + heading[0].getAttribute("id");

                if (headingPosition < 0) {
                    $('a[href="' + link + '"]').addClass('active');

                    $navLinks.each(function () {
                        $(this).removeClass("active");
                        $('a[href="' + link + '"]').addClass('active');
                    });
                }
            });
        }, 20);

        if (window.innerWidth > 991) {
            window.onscroll = (el) => { scrollSpyHandler(); };
        }

        //todo REMOVE OR REFACTOR SO IT'S NOT PUTTING A HANDLER ON ALL ELEMENTS
        $(":not(.ws-clustered-table-of-contents__heading)").click(function (event) {
            if (event.currentTarget === event.target) {
                let tableOfContentsHeading = $(".ws-accordion__header--active.ws-clustered-table-of-contents__heading");
                accordion.animateAccordion(tableOfContentsHeading);
            }
        });
        
        document.addEventListener("scroll", _throttle(positionAccordion, 20));
        window.addEventListener("resize", _throttle(onResize, 50));

        function calculateTotalMarginTop() {
            let $megamenu = $(".ws-megamenu")
            let $articleBodyPosition = $(".ws-article__body").offset().top;
            //ToC margin from the top: 70px
            let tableOfContentsMarginTop = $articleBodyPosition - $megamenu.height() - 70;

            return -(tableOfContentsMarginTop);
        }

        function setMarginTopBasedOnWindowSize() {
            let totalMarginTop = calculateTotalMarginTop();

            $clusteredTableOfContents.css("margin-top", window.innerWidth >= 992 ? totalMarginTop + "px" : "0");
            $clusteredTableOfContents.css("display", "block");
        }

        const throttledSetMarginTopBasedOnWindowSize = _throttle(setMarginTopBasedOnWindowSize, 200);

        // Call the function initially and when the window is resized call the function throttled
        if (!WS.isExperienceEditor()) {
            setMarginTopBasedOnWindowSize();
            $(window).on("resize", throttledSetMarginTopBasedOnWindowSize);
        }

        // Reposition the sidebar within the Table of Contents on page load and reveal it
        if (!$body.hasClass('pagemode-edit')) {
            // in Experience Editor mode, we want to disable appending sidebar so it doesn't interfere with editing.
            // Issue: appending sidebar in EE causes dulpicates
            let $sidebar = $(".ws-toc-sidebar");
            $sidebar.css("display", "");
            $clusteredTableOfContentsNotAccordion.append($sidebar);
        }

        function onResize() {
            bottomOfTable = $clusteredTableOfContents.offset().top + $clusteredTableOfContents.innerHeight();
            positionAccordion();
        }

        function positionAccordion() {
            // Checking if the current scroll position plus minified header plus minified TOC height is past the bottom of the expanded TOC
            if (window.innerWidth < 992 && ($(window).scrollTop() + stickyMiniHeaderHeight + stickyMiniTocHeight) > bottomOfTable) {
                if (!accordionIsOpen) {
                    accordionIsOpen = true;
                    $clusteredTableOfContentsAccordion.toggle(accordionIsOpen);
                }
            }
            else {
                if (accordionIsOpen) {
                    accordionIsOpen = false;
                    $clusteredTableOfContentsAccordion.toggle(accordionIsOpen);
                }
            }
        }
    }
});
